<div class="detail-items-panel">
  <div class="detail-items-header">
    <span class="execution-chip" [class.execution-chip--base]="executionType === 'Base'" [class.execution-chip--partner]="executionType === 'Parceiro'">
      <i class="fas" [class.fa-warehouse]="executionType === 'Base'" [class.fa-handshake]="executionType === 'Parceiro'"></i>
      {{ executionLabel() }}
    </span>
    <span class="text-muted" *ngIf="loadingEvidences">
      <i class="fas fa-spinner fa-spin"></i> Carregando evidências...
    </span>
  </div>

  <p class="collab-empty" *ngIf="!hasLines">Nenhum item cadastrado neste orçamento.</p>

  <article class="line-card" *ngFor="let line of lines">
    <header class="line-card__head" (click)="toggleLine(lineKey(line))">
      <div class="line-card__title">
        <span class="line-card__kind">{{ line.label }}</span>
        <strong>{{ line.description }}</strong>
      </div>
      <div class="line-card__meta">
        <span
          class="line-kind-badge"
          [class.line-kind-badge--preventiva]="isPreventiva(line)">
          {{ line.maintenanceKind }}
        </span>
        <span class="line-status" [ngClass]="approvalClass(line.approvalStatus)">{{ line.approvalStatus }}</span>

        <ng-container *ngIf="!isPreventiva(line); else preventivaMeta">
          <span class="line-billing" title="Quantidade × valor do item">
            {{ line.quantity }} × {{ formatCurrency(line.unitValue) }}
          </span>
          <span class="line-percent" *ngIf="canViewChargePercent" title="Percentual cobrado a mais">
            {{ formatChargeBump(line.chargePercent) }}
          </span>
          <strong class="line-charge" title="Valor de cobrança">{{ formatCurrency(line.totalValue) }}</strong>
        </ng-container>
        <ng-template #preventivaMeta>
          <span class="line-billing line-billing--muted">Sem cobrança</span>
          <strong class="line-charge">{{ formatCurrency(0) }}</strong>
        </ng-template>

        <span class="line-evidence-count" *ngIf="evidencesFor(line).length">
          <i class="fas fa-paperclip"></i> {{ evidencesFor(line).length }}
        </span>
        <i class="fas" [class.fa-chevron-down]="!isExpanded(lineKey(line))" [class.fa-chevron-up]="isExpanded(lineKey(line))"></i>
      </div>
    </header>

    <div class="line-card__body" *ngIf="isExpanded(lineKey(line))">
      <dl class="line-billing-detail" *ngIf="!isPreventiva(line)">
        <div>
          <dt>Valor do item</dt>
          <dd>{{ formatCurrency(line.unitValue) }}</dd>
        </div>
        <div *ngIf="canViewChargePercent">
          <dt>% a mais</dt>
          <dd>{{ formatPercent(line.chargePercent) }}</dd>
        </div>
        <div>
          <dt>Valor de cobrança</dt>
          <dd><strong>{{ formatCurrency(line.totalValue) }}</strong></dd>
        </div>
      </dl>
      <p class="line-billing-detail-note" *ngIf="isPreventiva(line)">
        Linha preventiva — valor do item e percentual não se aplicam; cobrança ao cliente é R$&nbsp;0,00.
      </p>

      <p class="line-rejection" *ngIf="line.rejectionReason">
        <strong>Motivo da recusa:</strong> {{ line.rejectionReason }}
      </p>

      <div class="line-evidence-toolbar">
        <label class="btn btn-outline-primary btn-sm mb-0" [class.disabled]="uploadingLineKey === lineKey(line)">
          <i class="fas" [class.fa-upload]="uploadingLineKey !== lineKey(line)" [class.fa-spinner]="uploadingLineKey === lineKey(line)" [class.fa-spin]="uploadingLineKey === lineKey(line)"></i>
          Anexar evidência
          <input type="file" hidden [disabled]="uploadingLineKey === lineKey(line)" (change)="onLineFileSelected($event, line)" />
        </label>
      </div>

      <div class="line-evidence-empty" *ngIf="evidencesFor(line).length === 0">
        Nenhuma foto ou documento neste item.
      </div>

      <div class="collab-gallery line-evidence-gallery" *ngIf="evidencesFor(line).length">
        <figure class="collab-photo" *ngFor="let e of evidencesFor(line)">
          <a *ngIf="isImage(e); else docLink" [href]="e.downloadUrl" target="_blank" rel="noopener">
            <img [src]="e.downloadUrl" [alt]="e.fileName" loading="lazy" />
          </a>
          <ng-template #docLink>
            <a class="line-doc-link" [href]="e.downloadUrl" target="_blank" rel="noopener">
              <i class="fas fa-file"></i> {{ e.fileName }}
            </a>
          </ng-template>
          <figcaption>
            <span class="collab-photo__name" [title]="e.fileName">{{ e.fileName }}</span>
            <span class="collab-when">{{ e.autor }} · {{ e.criadoEm | brDate:'dd/MM/yyyy' }}</span>
          </figcaption>
        </figure>
      </div>
    </div>
  </article>

  <section class="general-evidences" *ngIf="generalEvidencias.length">
    <h6 class="collab-subtitle"><i class="fas fa-folder-open"></i> Evidências gerais do orçamento ({{ generalEvidencias.length }})</h6>
    <div class="collab-gallery line-evidence-gallery">
      <figure class="collab-photo" *ngFor="let e of generalEvidencias">
        <a *ngIf="isImage(e); else generalDocLink" [href]="e.downloadUrl" target="_blank" rel="noopener">
          <img [src]="e.downloadUrl" [alt]="e.fileName" loading="lazy" />
        </a>
        <ng-template #generalDocLink>
          <a class="line-doc-link" [href]="e.downloadUrl" target="_blank" rel="noopener">
            <i class="fas fa-file"></i> {{ e.fileName }}
          </a>
        </ng-template>
        <figcaption>
          <span class="collab-photo__name" [title]="e.fileName">{{ e.fileName }}</span>
          <span class="collab-when">{{ e.autor }} · {{ e.criadoEm | brDate:'dd/MM/yyyy HH:mm' }}</span>
        </figcaption>
      </figure>
    </div>
  </section>
</div>
